// extracted by mini-css-extract-plugin
export var active = "mediaSlider-module--active--2f474";
export var anchored = "mediaSlider-module--anchored--c51e2";
export var layoutReduced = "mediaSlider-module--layoutReduced--65b83";
export var mainSwiper = "mediaSlider-module--mainSwiper--54520";
export var mediaDescription = "mediaSlider-module--mediaDescription--95813";
export var mediaSlideBtn = "mediaSlider-module--mediaSlideBtn--76a03";
export var mediaSlideContainer = "mediaSlider-module--mediaSlideContainer--8f6d5";
export var mediaSliderContainer = "mediaSlider-module--mediaSliderContainer--85ab7";
export var mediaSliderSection = "mediaSlider-module--mediaSliderSection--5800c";
export var swiperContainer = "mediaSlider-module--swiperContainer--9c64a";
export var thumbMediaSlide = "mediaSlider-module--thumbMediaSlide--0d651";
export var thumbSwiper = "mediaSlider-module--thumbSwiper--7367a";
export var thumbSwiperBlock = "mediaSlider-module--thumbSwiperBlock--ef8d2";